import React from 'react'

import Toast, { ToastProps } from '../../atoms/Toast'

interface SuccessToastProps extends ToastProps {
  message?: string
}

const SuccessToast: React.FC<SuccessToastProps> = ({ message, ...props }) => {
  if (!message) {
    return null
  }

  return (
    <Toast severity='success' {...props}>
      {message}
    </Toast>
  )
}

export default React.memo(SuccessToast)
